import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

const SignaturePad = forwardRef(({ height = 160 }, ref) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  const ctxOf = () => canvasRef.current.getContext("2d");

  const point = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ctxOf(); const { x, y } = point(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ctxOf(); const { x, y } = point(e); ctx.lineTo(x, y); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { drawing.current = false; };

  const clear = () => { const c = canvasRef.current; if (!c) return; ctxOf().clearRect(0, 0, c.width, c.height); setEmpty(true); };

  useImperativeHandle(ref, () => ({
    isEmpty: () => empty,
    clear,
    toBlob: () => new Promise((res) => canvasRef.current.toBlob(res, "image/png")),
  }));

  const init = (c) => {
    if (!c) return;
    canvasRef.current = c;
    c.width = c.offsetWidth || 460;
    c.height = height;
    const ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#1b3a2b";
  };

  return (
    <div>
      <canvas
        ref={init}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        style={{ height, touchAction: "none" }}
        className="w-full cursor-crosshair rounded-md border border-input bg-white"
        data-testid="signature-canvas"
      />
      <div className="mt-1 flex justify-end">
        <Button type="button" variant="ghost" size="sm" onClick={clear} data-testid="signature-clear-button" className="h-7 gap-1 text-xs text-muted-foreground">
          <Eraser className="h-3 w-3" /> Clear
        </Button>
      </div>
    </div>
  );
});

export default SignaturePad;
